import React from 'react';

import { SearchAIDialog } from '@atlassian/search-ai/ai-answer-dialog';
import { AITopicsCardByDocument } from '@atlassian/search-ai/ai-topics';

import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { mapFiltersToAggregator } from '../utils/filters.tsx';
import { useSearchInputContext } from '../SearchInputProvider.tsx';
import { useAnalytics } from '../AnalyticsProvider.tsx';
import { useSearchResultsContext } from '../SearchResultsProvider.tsx';

import { SmartAnswersWrapper, SmartAnswersLoadingWrapper } from './smart-answers-styles.tsx';

export const SmartAnswers = (): React.JSX.Element | null => {
	const { filters } = useSearchInputContext();
	const { cloudId, userId, displayName, edition, isAdminHubAIEnabled } = useSessionData();

	const { searchQuery, showSearchAI, aiTriggeredByAskAI, aiSearchConfig, onSearchQueryChange } =
		useSearchInputContext();
	const { searchSessionId } = useAnalytics();
	const parsedFilters = mapFiltersToAggregator(filters);

	const { results, loading: resultsLoading } = useSearchResultsContext();
	const { content: firstResultContent } = results[0] ?? {};
	const { id: firstResultId, type: firstResultType } = firstResultContent ?? {};

	const showAITopicsCard = !resultsLoading && !parsedFilters.length && isAdminHubAIEnabled;

	if (showSearchAI && aiSearchConfig && searchQuery) {
		return (
			<SearchAIDialog
				query={searchQuery}
				setQuery={onSearchQueryChange}
				cloudId={cloudId}
				getAIAnswer={aiSearchConfig.aiSearchQueryFunction}
				followUpsEnabled
				onNavigate={() => {}}
				searchSessionId={searchSessionId}
				userDetails={{
					name: displayName || '',
					id: userId || '',
				}}
				source="advancedSearch"
				sourceProduct="confluence"
				extraAnalyticsAttributes={{
					triggeredBy: aiTriggeredByAskAI ? 'askAIButton' : 'questionDetection',
				}}
				wrapper={({ children }) => <SmartAnswersWrapper>{children}</SmartAnswersWrapper>}
				loadingWrapper={({ children }) => (
					<SmartAnswersLoadingWrapper>{children}</SmartAnswersLoadingWrapper>
				)}
				parsedFilters={parsedFilters}
				edition={edition?.toString()}
				isAdminHubAIEnabled={isAdminHubAIEnabled}
				userGeneratedAI={aiTriggeredByAskAI}
			/>
		);
	}

	if (showAITopicsCard && fg('ai_topics_card_advanced_search')) {
		return (
			<AITopicsCardByDocument
				documentId={firstResultId}
				documentType={firstResultType}
				searchQuery={searchQuery}
				cloudId={cloudId}
				userId={userId ?? ''}
				userName={displayName ?? ''}
			/>
		);
	}

	return null;
};
